/** interfaces */
import { DsLinearFormInstanceWithTemplateInterface } from '../interfaces/ds-linear-form-instance-with-template.interface';
import { DsFormInstanceWithTemplate } from '../../ds-forms/models/ds-form-instance-with-template';
/** end interfaces */

export class DsLinearFormInstanceWithTemplate extends DsFormInstanceWithTemplate {
  /**
   *
   */
  public startKp: number;

  /**
   *
   */
  public endKp: number;

  /**
   * Creates an instance of DsFormInstanceWithTemplate.
   *
   * @param json the json data
   */
  constructor(json: DsLinearFormInstanceWithTemplateInterface) {
    super(json);
    this.startKp = json.start_pk;
    this.endKp = json.end_pk;
  }
}
